import { render, staticRenderFns } from "./MarkdownStory.vue?vue&type=template&id=6a01ef68&scoped=true&"
import script from "./MarkdownStory.vue?vue&type=script&lang=js&"
export * from "./MarkdownStory.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownStory.vue?vue&type=style&index=0&id=6a01ef68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a01ef68",
  null
  
)

export default component.exports